var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { ImageSize } from '@browsing/config';
export var updateItemImage = function (item, config) {
    var _a, _b, _c, _d;
    return (__assign(__assign({}, item), { imageUrl: config.getImage(((_b = (_a = item.media) === null || _a === void 0 ? void 0 : _a[0]) === null || _b === void 0 ? void 0 : _b.path) || item.imageUrl, ImageSize.Thumbnail), altText: ((_d = (_c = item.media) === null || _c === void 0 ? void 0 : _c[0]) === null || _d === void 0 ? void 0 : _d.alt_text) || item.name }));
};
export var transformCartForHeader = function (cart, config) { return (__assign(__assign(__assign({ items: cart.items.map(function (item) { return updateItemImage(item, config); }), info: cart }, ((cart === null || cart === void 0 ? void 0 : cart.unavailableItems) && {
    unavailableItems: cart.unavailableItems.map(function (item) { return updateItemImage(item, config); }),
})), ((cart === null || cart === void 0 ? void 0 : cart.cartType) && { cartType: cart.cartType })), ((cart === null || cart === void 0 ? void 0 : cart.isCartFromUnreservedCart) && {
    isCartFromUnreservedCart: cart.isCartFromUnreservedCart,
}))); };
